export const getSafeIntegrationErrorMetadata = (error: unknown) => ({
  errorType: error instanceof Error ? error.name : typeof error,
})
